/** The live `prefers-reduced-motion` query, or `null` without `matchMedia`. */
export const getReducedMotionQuery = () =>
    typeof window === "undefined" || typeof window.matchMedia !== "function"
        ? null
        : window.matchMedia("(prefers-reduced-motion: reduce)");

/** Whether the user asks for reduced motion right now. */
export const isReducedMotionPreferred = () =>
    getReducedMotionQuery()?.matches ?? false;
